module.exports = __webpack_public_path__ + "static/media/WA3F2030.de141dd3.svg";